/** Transport error kept framework-free so the signing core can report failures. */
export class ApiError extends Error {
  readonly status: number
  readonly detail: string

  constructor(status: number, message: string, detail = '') {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.detail = detail
  }

  get explanation(): string {
    switch (this.status) {
      case 401:
        return 'Your session has expired. Sign in again.'
      case 403:
        return 'This account does not have permission for that.'
      case 400:
        return this.detail || this.message
      case 502:
        return `The console could not reach the chain. ${this.detail}`
      case 503:
        return `This console is not configured for a chain. ${this.detail}`
      default:
        return this.detail || this.message
    }
  }
}
